import * as yup from 'yup';
import docs from './attachments';
import {
  acao,
  cpfBeneficiario,
  nascimentoBeneficiario,
  consentimentoDadosSensiveisBeneficiario,
  parentescoBeneficiario,
  situacaoParentesco,
} from './utils/rulesByKey';

export const dependentesIRSchema = yup.object({
  dependente: yup
    .string()
    .required('Atenção, Preencha o campo Nome completo do (a) Dependente'),
  ...cpfBeneficiario,
  ...nascimentoBeneficiario,
  maeDoDependente: yup.string().when('acao', {
    is: (value) => value !== 'Excluir',
    then: (field) =>
      field.required('Atenção, Preencha o campo Mãe do (a) Dependente'),
  }),
  paiDoDependente: yup.string().when('acao', {
    is: (value) => value !== 'Excluir',
    then: (field) =>
      field.required('Atenção, Preencha o campo Pai do (a) Dependente'),
  }),
  ...situacaoParentesco,
  ...parentescoBeneficiario,
  ...acao,
  ...consentimentoDadosSensiveisBeneficiario,
  ...docs.dependentesIRDocs.rules,
});

export const dependentesIRInitialValues = {
  dependente: '',
  cpf: '',
  nascimento: '',
  maeDoDependente: '',
  paiDoDependente: '',
  parentesco: '',
  situacaoParentesco: '',
  consentimentoDadosSensiveis: false,
  acao: '',
  ...docs.dependentesIRDocs.initialValues,
};

export const dependentesIRDocs = docs.dependentesIRDocs.docs;
